<template>
    <div :class="`calendar_content cal-${filter.key}`">
    </div>
</template>

<script>
    import * as moment from 'moment';

    export default {
        props: ['filter', 'filters'],
        data() {
            return {}
        },
        watch: {
            filters: function () {
                if (!this.filters || this.filters.length <= 0) {

                }
            }
        },
        methods: {},
        mounted: function () {
            const self = this;
            const el = $(`.cal-${self.filter.key}`);
            el.daterangepicker({
                "autoApply": true,
                "ranges": {
                    'Hoy': [moment(), moment()],
                    'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Últimos siete días': [moment().subtract(6, 'days'), moment()],
                    'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                    'Este mes': [moment().startOf('month'), moment().endOf('month')],
                    'Último mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                },
                "locale": {
                    "separator": " - ",
                    "applyLabel": "Aplicar",
                    "cancelLabel": "Cancelar",
                    "fromLabel": "Desde",
                    "toLabel": "hasta",
                    "customRangeLabel": "Personalizado",
                    "weekLabel": "S",
                    "daysOfWeek": [
                        "Do",
                        "Lu",
                        "Ma",
                        "Mi",
                        "Ju",
                        "Vi",
                        "Sa"
                    ],
                    "monthNames": [
                        "Enero",
                        "Febrero",
                        "Marzo",
                        "Abril",
                        "Mayo",
                        "Junio",
                        "Julio",
                        "Augosto",
                        "Septiembre",
                        "Octubre",
                        "Noviembre",
                        "Diciembre"
                    ],
                    "firstDay": 1
                },
                "applyButtonClasses": "btn btn2",
                "cancelButtonClasses": "dtCancelButton",
                "alwaysShowCalendars": true,
                "parentEl": `.cal-${self.filter.key}`,
                "endDate": moment(),
            });

            el.on('apply.daterangepicker', function (e, data) {
                self.$emit("change", self.filter, {startDate: data.startDate, endDate: data.endDate});
            });

            setTimeout(() => {
                el.data('daterangepicker').show();
            }, 100);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/FilterDate.vue